var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"verifyIng"}},[_c('div',{staticClass:"title"},[_vm._v("申诉中")]),_c('div',{staticClass:"cont"},[_vm._v("您的实名认证信息正在审核中，实名结果约5-7个工作日后公布，请您耐心等待")])])
}]

export { render, staticRenderFns }